import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useTranslation } from "react-i18next";
import * as Locale from "@mywvglobal-shared/mywv-shared/locales";
//import EDITICON from "../../images/edit_icon.svg";
import { AddChildCloseIcon, SendMessageButton, PreviewContent } from "../atoms/ConnectStories";
import AppStyles from "../../config/styles";
import Modal from "react-bootstrap/Modal";
import * as SendMessageAction from "@mywvglobal-shared/mywv-shared/action/sendMessageAction";
import * as ErrorUtilities from "../../utilities/errorUtilities";
import ApiConstants from "@mywvglobal-shared/mywv-shared/api/apiConstant";
import * as ErrorAction from "@mywvglobal-shared/mywv-shared/action/errorActions";
import { constants } from "../../constants";
import { logoutUser } from "../../utilities/LogOutUtils";
import * as LogoutAction from "@mywvglobal-shared/mywv-shared/action/persistItemsAction";
import useApiRepository from "../../api/useApiRepository";
import MessageSuccess from "./ConnectStoriesComponent/MessageSuccess";
import { Error, ErrorClose } from "../atoms/Error";

function WriteAmessagePreview(props) {
  const dispatch = useDispatch();
  const bordersData = props?.previewData?.bordersData;
  const requestBase = props?.previewData;
  const subject = props?.previewData?.subject;
  const messageBody = props?.previewData?.messageBody;
  const imageURI = props?.previewData?.imageURI;
  const { t } = useTranslation();
  const { persistItemsReducer } = useSelector((state) => state);
  const { loginReducer } = useSelector((state) => state);
  const { sendAMessageReducer } = useSelector((state) => state);
  const apiRepo = useApiRepository();
  const [isListVisible, setIsListVisible] = useState(false);
  const [selectedBorder, setSelectedBorder] = useState();
  const [isDefaultBorderVisible, setDefaultBorderVisible] = useState(false);
  const [openSuccess, setOpenSuccess] = useState(false);
  const [loading, setLoading] = useState(true);
  const [statusTracking, setStatusTracking] = useState([]);
  const [disable, setDisable] = useState(false);
  const [mailSentError, setMailSentError] = useState(false);
  const styles = {
    container: {
      flex: 1,
    },
    listViewStyles: {
      flex: 0.22,
      paddingHorizontal: "10px",
      backgroundColor: "white",
    },
    previewStyles: {
      flex: 0.65,
      padding: "0 20px",
    },
    fullPreviewStyles: {
      flex: 0.85,
      padding: "10px",
    },
    imgView: {
      height: "106px",
      width: "auto",
      alignSelf: "center",
      marginBottom: "20px",
      objectFit: "cover",
    },
    btnViewStyles: {
      display: "flex",
      paddingHorizontal: "10px",
      justifyContent: "center",
      alignItems: "center",
      textAlign: "center",
    },
    headingStyles: {
      fontFamily: "Lato",
      fontSize: "20px",
      color: "rgba(0, 0, 0, 1)",
      paddingVertical: "5px",
      textAlign: "left",
      paddingLeft: "6%",
    },
    contentStyles: {
      fontFamily: "Lato-Bold",
      fontSize: "14px",
      color: "rgba(0, 0, 0, 1)",
      paddingVertical: "5px",
    },
    buttonviewstyle: {
      borderRadius: "8px",
      backgroundColor: AppStyles.colors.COLOR_ORANGE,
      padding: "10px",
      boxShadow: "rgb(199, 83, 0) 0px 3px 0px",
      width: "88%",
    },
    buttonviewstyledisable: {
      borderRadius: "8px",
      backgroundColor: AppStyles.colors.COLOR_ORANGE,
      padding: "10px",
      boxShadow: "rgb(199, 83, 0) 0px 3px 0px",
      opacity: "0.5",
      pointerEvents: "none",
    },
    buttontextstyle: {
      color: AppStyles.colors.COLOR_WHITE,
      fontSize: "20px",
      fontFamily: "Lato-Bold",
      textAlign: "center",
    },
    scrollStyles: {
      height: "70%",
      width: "70%",
      alignSelf: "center",
      marginVertical: "60px",
      padding: "10px",
    },
    scroll2Styles: {
      marginVertical: "80px",
      padding: "10px",
      width: "70%",
      height: "70%",
      alignSelf: "center",
    },
    textStyles: {
      color: "rgba(0,0,0,1)",
      fontFamily: "Lato",
      fontSize: "16px",
      marginBottom: "15px",
      wordWrap: "break-word",
    },
    editViewStyles: {
      flexDirection: "row",
      backgroundColor: "white",
      padding: "5px 10px",
      borderRadius: "20px",
      alignSelf: "center",
      position: "absolute",
      right: "30px",
      top: "17%",
      zIndex: 1,
      border: "1px solid #E6E6E6",
    },
    editFullStyles: {
      flexDirection: "row",
      backgroundColor: "white",
      padding: "5px 10px",
      borderRadius: "20px",
      alignSelf: "center",
      position: "absolute",
      right: "30px",
      top: "95px",
      zIndex: 1,
      border: "1px solid #E6E6E6",
    },
    editTextStyles: {
      color: "rgba(17, 17, 17, 1)",
      fontFamily: "Lato-Bold",
      fontSize: "14px",
      marginLeft: "5px",
    },
  };

  const setConfigBasedValues = () => {
    const letterTemplateValues = loginReducer?.getSOConfiguration?.letterTemplateSettings;
    if (letterTemplateValues && letterTemplateValues?.borders) {
      if (bordersData && bordersData.length > 0) {
        setSelectedBorder(bordersData[0]);
      }
    }
    if (letterTemplateValues && letterTemplateValues?.defaultBorder) {
      setDefaultBorderVisible(true);
    }
  };

useEffect(() => {
  dispatch(SendMessageAction.hideSendAMessageReducer());
  const { sendAMessageResponse, errorMessage } = sendAMessageReducer || {};
  if (!sendAMessageResponse) return;
  const { status, messageDetails } = sendAMessageResponse || {};
  if (status === "Success" && messageDetails) {
    props.onClose();
    setStatusTracking(messageDetails?.[0]?.statusTracking);
    setLoading(false);
    setOpenSuccess(true);
    dispatch(SendMessageAction.clearSendAMessageFeedReducer());
    return;
  }
  if (errorMessage?.status) {
    if (errorMessage?.statusCode === "429") {
      setMailSentError(true);
    }
    dispatch(SendMessageAction.clearSendAMessageFeedReducer());
    try {
      const request = ErrorUtilities.sendErrorEmail(
        loginReducer?.getSOConfiguration,
        persistItemsReducer,
        errorMessage,
        ApiConstants.SEND_MESSAGE
      );
      props.onClose();
      if (request) {
        dispatch(ErrorAction.sendErrorReportRequest(request));
      }
    } catch (excp) {
      // TODO: Error should be handled through DB logs or analytics
    }
  }
}, [sendAMessageReducer?.sendAMessageResponse]);

  useEffect(() => {
    setDisable(false);
    Locale.setLanguage(persistItemsReducer?.selectedSOData?.soLanguageCultureCode);
    if (bordersData && bordersData.length > 0) {
      setIsListVisible(true);
    }
    setConfigBasedValues();
  }, [props?.previewData]);

  const onSendMessageClick = () => {
    setDisable(true);
    apiRepo.connectRepository.sendMessage(
      requestBase,
      selectedBorder,
      isDefaultBorderVisible,
      props?.letterWritingLanguageCode,
      persistItemsReducer?.selectedSOData?.soLanguageCultureCode,
    );
    props?.onSendMailandClose();
  };

  async function handleUnauthorizedTokenError() {
    await logoutUser({
      persistItemsReducer, loginReducer, dispatch,
      LogoutAction, constants,
    });
  }

  useEffect(() => {
    // if token is expired or unauthorized, logout user
    if (sendAMessageReducer?.errorMessage?.status === 401) {
      handleUnauthorizedTokenError()
      return
    }
  }, [sendAMessageReducer?.errorMessage?.status]);
  const handleMailSentErrorClose =() => {
    setMailSentError(false);
  }

  return (
    <>
      <Modal
        className="preview-popup"
        show={props?.isVisible}
        dialogClassName="vertical-custom-modal"
      >
        <AddChildCloseIcon onClick={props?.onClose}>X</AddChildCloseIcon>
        <div style={styles.container}>
          <div style={styles.listViewStyles}>
            <div style={styles.headingStyles}>{t("PersonaliseMessage")}</div>
          </div>
          <div style={isListVisible ? styles.previewStyles : styles.fullPreviewStyles}>
            <img
              className="preview-border-image"
              src={selectedBorder?.mediaURL}
              alt="" />
            <PreviewContent>
              <div style={styles.textStyles}>{subject}</div>
              <pre style={styles.textStyles}>{messageBody}</pre>
              <div className="preview-image">
                {imageURI
                  && <img style={styles.imgView} src={(`data:image/png;base64,${imageURI}`)} alt="" />}
              </div>
            </PreviewContent>
          </div>
          <div style={styles.btnViewStyles}>
            <SendMessageButton style={disable ? styles.buttonviewstyledisable : styles.buttonviewstyle} onClick={onSendMessageClick}>
              <span style={styles.buttontextstyle}>{t("SendMessage")}</span>
            </SendMessageButton>
          </div>
        </div>
      </Modal>
       {mailSentError ? (
        <Error>
          <h2><span>{t("MailSentErrorTitle")}</span></h2>
          <p>{t("MailSentErrorMessage")}</p>
          <ErrorClose onClick={handleMailSentErrorClose}/>
        </Error>
      ) : null}
      {openSuccess && <MessageSuccess show={openSuccess} closeBtnClick={setOpenSuccess} loading={loading}
        selectedTemplate={props?.selectedTemplate}
        childFirstName={props?.childFirstName}
        childImageURL={props?.childImageURL}
        selectedChildData={props?.selectedChildData}
        isCelebrationChild={props?.isCelebrationChild}
        recipientsList={props.recipientsList} statusTracking={statusTracking} successModalClose={props.successModalClose} />}
    </>

  );
}
export default WriteAmessagePreview;
